import { secondsInPast } from '../../Utils/time';

const filterAndSortApproaching = (data, config) => {
  /* || status === 'ontrack' /* && secondsInPast(new Date(updated), config.delayDataSeconds || 60))*/
  return [...data]
    .filter(({ status, result, updated }) => {
      return status === 'ontrack' && result.status && result.status === 'active';
    })
    .sort((a, b) => {
      let aRank = a.result.rank;
      let bRank = b.result.rank;
      // if (a.result_changes) {
      //   const aRankChange = a.result_changes.filter(
      //     (change) => change.type === 'rank'
      //   )[0];
      //   if (aRankChange) {
      //     const aChangeInPast = secondsInPast(
      //       new Date(aRankChange.updated),
      //       config.delayDataSeconds || 60
      //     );
      //     aRank = aChangeInPast ? aRankChange.current : aRankChange.previous;
      //   }
      // }
      // if (b.result_changes) {
      //   const bRankChange = b.result_changes.filter(
      //     (change) => change.type === 'rank'
      //   )[0];
      //   if (bRankChange) {
      //     const bChangeInPast = secondsInPast(
      //       new Date(bRankChange.updated),
      //       config.delayDataSeconds || 60
      //     );
      //     bRank = bChangeInPast ? bRankChange.current : bRankChange.previous;
      //   }
      // }
      aRank = parseInt(aRank, 10);
      bRank = parseInt(bRank, 10);
      return !aRank ? 1 : !bRank || aRank < bRank ? -1 : aRank > bRank ? 1 : 0;
    });
};

export { filterAndSortApproaching };
